module.exports = __webpack_public_path__ + "img/B.4ba7d82a.jpg";